import gsap from "gsap";
import Power1 from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import barba from "@barba/core";

import modaal from "modaal";
//- import { get } from "jquery";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const breakpoint = 768;
const loadEvent = true;//--ロード画面は省略可能 for Dev
const testDir = '';//--テスト時のディレクトリ(sample: /test)

let windowWidth = 0;
let windowHeight = 0;
let contentsHeight = 0;
let isPC = false;
let isSP = false;

let navPosition = 0;
let bracket = 0;
let beforePosition;
let ancherProducts;
let footerHeight;
let navHeight;
let $fixObj;

let $loader;
let $loaderBase;

let currentPagePath = "";

//--WindowSize

const setSizes = (isFirst = false) => { //-初回ロードのみ true を指定
  //--画面サイズ
  windowWidth = window.innerWidth;
  windowHeight = window.innerHeight;
  contentsHeight = $("#common-wrapper").outerHeight();

  if (windowWidth > breakpoint) {
    isPC = true;
    isSP = false;
  } else {
    isPC = false;
    isSP = true;
  }

  footerHeight = $('#footer').outerHeight();
  navHeight = $("#navigation").outerHeight();

  $('.fixbottom').css({ height: footerHeight + navHeight });

  let footerMargin = 60;
  if (isSP) { footerMargin = 100}


  //-ナビゲーション固定位置
  setTimeout(() => {
    let beforeNavPosition = navPosition;
    navPosition = $('.fixbottom').offset().top + footerHeight + navHeight- footerMargin;

    if (beforeNavPosition != 0 && navPosition > windowHeight) {
      navigationMove("fixed");
    } else if (beforeNavPosition != 0 && navPosition < windowHeight) {
      navigationMove("relative");
    }

  }, 200);


};

//-monitorWindowsize

setInterval(
  function () {
    //-コンテンツサイズの変更
    if (contentsHeight != $("#common-wrapper").outerHeight()) {
      setSizes();
      return 0;
    }

    //-windowサイズ変更
    if (windowWidth != window.innerWidth) {
      if (windowHeight != window.innerHeight) {
        setSizes();
     }
    }
  }
  , 500);


//-LOADING

if (loadEvent) {//-初回ロード後

  const loaderHide = () => {

    clearTimeout(loadLimit);

    $loader = document.getElementById("js-loader");
    $loaderBase = document.getElementById('js-loader-base');
    $fixObj = $('.fixobj');
    $('.fixbottom').css({ height: footerHeight + navHeight });


    // setSizes();
    // init();

    setAnimation();
    $fixObj.css({ bottom: -(footerHeight + navHeight) });

    gsap.to($loader, {
      opacity: 0,
      duration:0.3,
      onComplete: function () {
        $loader.style.pointerEvents = "none";
      }
    });

    gsap.to($loaderBase, {
      opacity: 0,
      delay:0,
      duration:0.3,
      onComplete: function () {
        $loaderBase.style.pointerEvents = "none";
      }
    });

  }

  const loadLimit = setTimeout(
     () => {
      window.removeEventListener('load', loaderHide);
      loaderHide();
    },
    2000
  );

  window.addEventListener('load', loaderHide);

} else {
  const $loader = document.getElementById("js-loader"),
    $loaderBase = document.getElementById('js-loader-base');
    $loader.style.display = "none";
    $loaderBase.style.display = "none";
}


//--ナビゲーション
const setNavigation = (name) => {
  beforePosition = window.scrollY;

  window.addEventListener('scroll', () => {

      var resizeTimer;

      if (!resizeTimer) {
        clearTimeout(resizeTimer);
      }

      resizeTimer = setTimeout(function () {
        onScroll();
      }, 300);
      const onScroll = () => {
        let offset = window.scrollY - beforePosition;
        beforePosition = window.scrollY;

        if (window.scrollY + windowHeight >= navPosition) {
          navigationMove("relative");
        } else {
        if (offset < -10) {
          navigationMove("fixed");
        }
        else if (offset > 10){
          navigationMove("fixed");
        }
      }
    }


  });

}

//-ページ遷移後のリンク変更
const setNavlink = (path) => {
  if (path.match("^.*/fe_fs/$") != null || path.match("^.*/fe_fs/index.html$") != null) {//第一階層
    if (bracket == 2) {
      $('.nav-item a').each((index, element) => {
        let hreftext = $(element).attr('href').slice(1);
        $(element).attr('href', hreftext);
      });
    }
    bracket = 1;
  } else {
    if (bracket == 0 || bracket == 1) {
      $('.nav-item a').each((index, element) => {
        let hreftext = '.' + $(element).attr('href');
        $(element).attr('href', hreftext);
      });
    }
    bracket = 2;
  }

}

const navigationMove = (state) => {

  switch (state) {
    case "fixed":
      gsap.to($fixObj, {
        duration: 0.5,
        delay: 0,
        opacity: 1,
        position: "fixed",
        bottom:-footerHeight,
        ease: Power1.easeOut
      });
      gsap.to($('#navigation .pagetop img'), {
        duration: 0.5,
        delay: 0,
        opacity: 0,
        pointerEvents:"none",
        ease: Power1.easeOut
      });
      break;
    case "hide":
      gsap.to($fixObj, {
        duration: 0.3,
        delay: 0,
        opacity: 1,
        position: "fixed",
        bottom:-footerHeight-navHeight,
        ease: Power1.easeOut
      });
      gsap.to($('#navigation .pagetop img'), {
        duration: 0.5,
        delay: 0,
        opacity: 0,
        pointerEvents:"none",
        ease: Power1.easeOut
      });
      break;
    case "relative":
      gsap.to($fixObj, {
        duration: 0.5,
        delay: 0.2,
        opacity: 1,
        bottom:0,
        position:"fixed",
        ease: Power1.easeOut
      });
      gsap.to($('#navigation .pagetop img'), {
        duration: 0.5,
        delay: 0.2,
        opacity: 1,
        pointerEvents:"all",
        ease: Power1.easeOut
      });
      break;
  }

}

//--アニメーション関連

const setAnimation = () => {

  switch (currentPagePath) {

    case testDir+'/fe_fs/'://-トップページ

      if (ancherProducts) {
        let position = $('#products').offset().top - 50;
        setTimeout(() => {
          $('body,html').stop().animate({ scrollTop: position }, 1000, 'swing');
        },1500)

      }

      navProductInnerLink(true);

      setTimeout(function () {
        navigationMove("fixed")
      }, 3000);

      setTimeout(function () {
        $(".hero-image").addClass('animated');
      }, 500);

      gsap.from(".hero-image img", {
        duration: 2.8,
        delay: 1,
        opacity: 0,
        scale: 1.5,
        ease: Power1.easeOut
      });
      gsap.from(".hero-switchlogo", {
        duration: 1.4,
        delay: 2,
        opacity: 0,
        ease: Power1.easeOut
      });

      if (isPC) {
        gsap.from(".hero-content .container", {
          duration: 1.8,
          delay: 1,
          opacity: 0,
          x:40,
          ease: Power1.easeOut
        });
      }
      if (isSP) {
        gsap.from(".hero-content", {
          duration: 1.8,
          delay: 1,
          opacity: 0,
          y:40,
          ease: Power1.easeOut
        });
      }
      gsap.from(".hero-copy__item--01", {
        duration: 0.5,
        delay: 2.5,
        opacity: 0,
        height:0,
        ease: Power1.easeOut
      });
      gsap.from(".hero-copy__item--02", {
        duration: 0.5,
        delay: 2.8,
        opacity: 0,
        height:0,
        ease: Power1.easeOut
      });
      if (isPC) {
        // if (windowHeight / windowWidth > 0.52) {
        //   if (windowWidth > 1500 || windowHeight / windowWidth > 0.6) {
        //     gsap.to(".hero-banner", {
        //       position: "absolute",
        //       left: 40,
        //       bottom:40,
        //       scrollTrigger: {
        //         trigger: ".world-bg",
        //         start:'top bottom',
        //         end: '+=100 center',
        //         scrub: true
        //       }
        //     });
        //   } else {
        //     $(".hero-banner").css({ position:'absolute'});
        //   }
        // } else {
        //   $(".hero-banner").css({ position:'absolute'});
        // }
      }
      gsap.from(".world-bg", {
        opacity: 0,
        duration: 0.5,
        scale:1.4,
        scrollTrigger: {
          trigger: ".world-bg",
          start:'top center',
          end: 'bottom center',
          scrub:true
        }
      });
      gsap.from(".world-bg", {
        onComplete: () => {
          if ($('#video_world').length > 0) {
            $('#video_world').get(0).currentTime = 0;
            $('#video_world').get(0).play(0);
          }
        }
      });
      gsap.from(".system-bg .bg--01 img", {
        scrollTrigger: ".system-bg",
        duration: 1.5,
        delay: 0.5,
        opacity:0,
        scale:1.2,
        ease: Power1.easeOut
      });
      gsap.from(".system-bg .bg--02 img", {
        scrollTrigger: ".system-bg",
        duration: 1.5,
        delay: 1,
        opacity:0,
        scale:1.2,
        ease: Power1.easeOut
      });
      gsap.from(".background__img--base", {
        scrollTrigger: {
          trigger: ".products-section",
          start: 'top center',
          scrub:true
        },
        y: 600,
      });


      let tgtClass = '.fadeinAnimation';

      for (var i = 0; i < $(tgtClass).length; i++) {
        $(tgtClass).eq(i).addClass('anim' + i);
        gsap.from(tgtClass+'.anim' + i, {
          scrollTrigger: tgtClass+'.anim' + i,
          duration: 0.5,
          delay:0,
          opacity: 0
        });
      }

      tgtClass = '.fadeinupAnimation';

      for (var i = 0; i < $(tgtClass).length; i++) {
        $(tgtClass).eq(i).addClass('anim' + i);
        gsap.from(tgtClass+'.anim' + i, {
          scrollTrigger: {
            trigger: tgtClass + '.anim' + i,
            start: 'top 90%',
            end: 'top 50%'

          },
          duration: 1,
          delay: 0.1,
          y:40,
          opacity: 0
        });
      }
      break;


    case testDir+'/fe_fs/world/'://世界観
      navProductInnerLink(false);
      lowerDefaultAnimation();

      gsap.from(".headline-catch img", {
        duration: 1.6,
        delay: 1,
        opacity: 0,
        scale:1.05,
        ease: Power1.easeOut
      });

      gsap.from(".headline-leadtext", {
        duration: 1.6,
        delay: 1,
        opacity: 0,
        y:20,
        ease: Power1.easeOut
      });

      gsap.from(".headline-screenshots", {
        duration: 1.6,
        delay: 1.5,
        opacity: 0,
        ease: Power1.easeOut
      });

      gsap.from(".character-img--01", {
        scrollTrigger: ".character-block-hero",
        duration: 1.6,
        delay: 0.5,
        x:30,
        opacity: 0,
        ease: Power1.easeOut
      });

      gsap.from(".character-img--02", {
        scrollTrigger: ".character-block-hero",
        duration: 1.6,
        delay: 0.5,
        x:-30,
        opacity: 0,
        ease: Power1.easeOut
      });

      gsap.from(".character-block-01 .character-img", {
        scrollTrigger: ".character-block-01",
        duration: 1.6,
        delay: 0.5,
        x:30,
        opacity: 0,
        ease: Power1.easeOut
      });

      gsap.from(".character-block-01 .character-name img", {
        scrollTrigger: ".character-block-01",
        duration: 1.6,
        delay: 0.6,
        opacity: 0,
        ease: Power1.easeOut
      });

      gsap.from(".character-block-02 .character-img", {
        scrollTrigger: ".character-block-02",
        duration: 1.6,
        delay: 0.5,
        x:-30,
        opacity: 0,
        ease: Power1.easeOut
      });
      gsap.from(".character-block-02 .character-name img", {
        scrollTrigger: ".character-block-02",
        duration: 1.6,
        delay: 0.6,
        opacity: 0,
        ease: Power1.easeOut
      });

      gsap.from(".character-block-03 .character-img", {
        scrollTrigger: ".character-block-03",
        duration: 1.6,
        delay: 0.5,
        x:30,
        opacity: 0,
        ease: Power1.easeOut
      });
      gsap.from(".character-block-03 .character-name img", {
        scrollTrigger: ".character-block-03",
        duration: 1.6,
        delay: 0.6,
        opacity: 0,
        ease: Power1.easeOut
      });

      tgtClass = '.fadeinAnimation';

      for (var i = 0; i < $(tgtClass).length; i++) {
        $(tgtClass).eq(i).addClass('anim' + i);
        gsap.from(tgtClass+'.anim' + i, {
          scrollTrigger: tgtClass+'.anim' + i,
          duration: 1,
          delay:0.3,
          opacity: 0
        });
      }

      tgtClass = '.fadeinupAnimation';

      for (var i = 0; i < $(tgtClass).length; i++) {
        $(tgtClass).eq(i).addClass('anim' + i);
        gsap.from(tgtClass+'.anim' + i, {
          scrollTrigger: {
            trigger: tgtClass + '.anim' + i,
            start: 'top 80%',
            end: 'top 50%'
          },
          duration: 1,
          delay: 0.3,
          y:40,
          opacity: 0
        });
      }

      gsap.from(".background__img--base", {
        scrollTrigger: {
          trigger: ".headline-section",
          start: 'top center',
          scrub:true
        },
        y: 2000,
      });

      break;

    case testDir+'/fe_fs/movie/'://-ムービー
      navProductInnerLink(false);
      lowerDefaultAnimation();
      break;

    case testDir+'/fe_fs/special/'://-ムービー
    navProductInnerLink(false);
    lowerDefaultAnimation();
      break;

    case testDir+'/fe_fs/update/'://-ムービー
    navProductInnerLink(false);
    lowerDefaultAnimation();
      break;

    case testDir+'/fe_fs/trial/'://-ムービー
    navProductInnerLink(false);
    lowerDefaultAnimation();
      break;

    case testDir+'/fe_fs/usersvoice/'://-ムービー
      navProductInnerLink(false);
      lowerDefaultAnimation();

      gsap.from(".product-fixed img", {
        duration: 1,
        delay: 1.2,
        opacity: 0,
        x:100
      });

      gsap.to(".product-fixed", {
        scrollTrigger: {
          trigger: ".footer-banner",
          start: 'top bottom',
          end: 'top bottom',
          scrub: true
        },
        opacity: 0,
        duration:1,
      });


      break;

    case testDir + '/fe_fs/soundtrack/'://-サウンドトラック
      navProductInnerLink(false);
      lowerDefaultAnimation();

      $(".js-list").css({
        overflow: "hidden",
        height: 0,
        margin:0
      });

      $(".js-btn-open").on("click", function () {

        if ($(".js-list").outerHeight() != 0) {

          $(".js-list").css({
            height: 0
          });

        } else {

          $(".js-list").css({
            height: "auto",
            marginTop:"1em"
          });

        }

      });

      break;


    case testDir+'/fe_fs/system/'://-ムービー
      navProductInnerLink(false);
      lowerDefaultAnimation();

      tgtClass = '.fadeinupAnimation';

      for (var i = 0; i < $(tgtClass).length; i++) {
        $(tgtClass).eq(i).addClass('anim' + i);
        gsap.from(tgtClass+'.anim' + i, {
          scrollTrigger: {
            trigger: tgtClass + '.anim' + i,
            start: 'top 80%',
            end: 'top 50%'

          },
          duration: 1,
          delay: 0.3,
          y:40,
          opacity: 0
        });
      }
      gsap.from(".background__img--base", {
        scrollTrigger: {
          trigger: ".headline-section",
          start: 'top center',
          scrub:true
        },
        y: 2000,
      });

      break;
    default :
      navProductInnerLink(false);
      lowerDefaultAnimation();
      break;
  }
}

const navProductInnerLink = (state) => {

  if (state) {
    $('a[href^="/fe_fs/#products"]').on('click', function(event) {
      event.preventDefault();

      let decodedHash = decodeURI(this.hash);
      let hash = decodedHash == "#" || decodedHash == "" ? 'html' : decodedHash;
      scrollToAnker(hash);

      return false;
    });
  } else {
    $('a[href^="/fe_fs/#products"]').off('click');
  }
}

//-- 下層用デフォルトアニメーション

const lowerDefaultAnimation = () => {

  setTimeout(function () {
    navigationMove("fixed")
  },0);

  gsap.from(".headline", {
    duration: 1,
    delay: 0,
    opacity: 0,
    scale:0.9,
    ease: Power1.easeOut
  });
  gsap.from(".headline img", {
    duration: 2,
    delay: 0,
    y:20,
    opacity: 0,
    ease: Power1.easeOut
  });
  gsap.from(".headline-text", {
    duration: 2.4,
    delay: 0.5,
    opacity:0,
    ease: Power1.easeOut
  });
  gsap.from(".content-section", {
    duration: 2.4,
    delay: 0.5,
    opacity:0,
    ease: Power1.easeOut
  });
  gsap.from(".headline-bg", {
    duration: 2.4,
    delay: 0.5,
    opacity: 0,
    y:-30,
    ease: Power1.easeOut
  });
  gsap.from(".background__img--base", {
    duration: 2.4,
    delay: 0.5,
    opacity: 0,
    y:-30,
    ease: Power1.easeOut
  });
}

const init = () => { //- ページ読み込み後の初期化 初回のみ

  //- ページの状態をグローバルにセット

  ancherProducts = false;//-アンカーのリセット
  currentPagePath = location.pathname.replace("index.html", "");
  if ((currentPagePath.slice(-1)) != '/') {
    currentPagePath += '/';
  }
  let hash = location.hash;
  if (hash == "#products") {
    ancherProducts = true;
  }


  $('a[href^="#"]').on('click', function (event) {
    if (!$(event.currentTarget).hasClass('modal-chara')) {//-キャラのポップアップ回避
      event.preventDefault();

      let decodedHash = decodeURI(this.hash);
      let hash = decodedHash == "#" || decodedHash == "" ? 'html' : decodedHash;
      scrollToAnker(hash);
    }

    return false;
  });

  //-ナビゲーション

  setNavlink(currentPagePath);


  //-modal
  if ($('.modal-m').length != 0) {
    $('.modal-m').modaal({
      background: 'transparent',
      type:'video',
      before_open: function (e) {
        $("#content").css({ "filter": "blur(5px)" });
        $("#navigation").css({ "filter": "blur(5px)" });
        $("#footer").css({ "filter": "blur(5px)" });
        if (currentPagePath == testDir + '/fe_fs/') { $(".hero-section").css({ "filter": "blur(5px)" }); }
      },
      before_close: function (e) {
        $("#content").css({ "filter": "blur(0)" });
        $("#navigation").css({ "filter": "blur(0)" });
        $("#footer").css({ "filter": "blur(0)" });
        if (currentPagePath == testDir + '/fe_fs/') { $(".hero-section").css({ "filter": "blur(0)" }); }
      }
    });
  }
  if ($('.modal-i').length != 0) {
    $('.modal-i').modaal({
      background: 'transparent',
      type:'image',
      before_open: function (e) {
        $("#content").css({ "filter": "blur(5px)" });
        $("#navigation").css({ "filter": "blur(5px)" });
        $("#footer").css({ "filter": "blur(5px)" });
        if (currentPagePath == testDir + '/fe_fs/') { $(".hero-section").css({ "filter": "blur(5px)" }); }
      },
      before_close: function (e) {
        $("#content").css({ "filter": "blur(0)" });
        $("#navigation").css({ "filter": "blur(0)" });
        $("#footer").css({ "filter": "blur(0)" });
        if (currentPagePath == testDir + '/fe_fs/') { $(".hero-section").css({ "filter": "blur(0)" }); }
      }
    });
  }

  switch (currentPagePath) {
    case testDir + '/fe_fs/': //-トップページ
      if (isPC) {
        new Swiper('.movie-slider', {
          slidesPerView: 2,
          spaceBetween: 20,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          }
        });
      } else { //-SP
        new Swiper('.movie-slider', {
          slidesPerView: 1.5,
          spaceBetween: 10,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          }
        });
      }


      //- 動画追加
      $('.world-bg').html('<video muted autoplay playsinline loop id ="video_top_world"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/top_world.webm" type="video/webM"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/top_world.mp4" type="video/mp4"></video>');

      break;


    case testDir + '/fe_fs/world/': //-世界観ページ

      const hash = location.hash;
      if (hash != "") {
        setTimeout(() => {
          let position = $(hash).offset().top - 50;
          $('body,html').stop().animate({ scrollTop: position }, 800, 'swing');
        }, 2000);
      }

      //-スクリーンショット部分の複製　アニメーションはp-world.scss
      let screenshotContent = $('.headline-screenshots ul').html();
      $('.headline-screenshots ul').append(screenshotContent);

      //- 動画追加
      $('.headline-bg').html('<video muted autoplay playsinline loop id ="video_world"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/world.webm" type="video/webm"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/world.mp4" type="video/mp4"></video>');



      //- キャラクターモーダル
      const charaModalLength = [3, 8, 8, 8, 4];
      const facialLength = 3;
      const modalTarget = document.getElementById('js-modalarea');
      let modalSlider1, modalSlider2, modalSlider3, modalSlider4, modalSlider5;
      const tweetLink = "https://twitter.com/intent/tweet?text=";
      const tweetTexts = [
        " | 体験版配信中！分岐する3つの章がエピソード4まで遊べる - ファイアーエムブレム無双 風花雪月",
        " | 体験版配信中！分岐する3つの章がエピソード4まで遊べる - ファイアーエムブレム無双 風花雪月",
        " | 体験版配信中！分岐する3つの章がエピソード4まで遊べる - ファイアーエムブレム無双 風花雪月",
        " | 体験版配信中！分岐する3つの章がエピソード4まで遊べる - ファイアーエムブレム無双 風花雪月",
        " | 体験版配信中！分岐する3つの章がエピソード4まで遊べる - ファイアーエムブレム無双 風花雪月"
      ];
      const tweetCharaNames = [
        [
          "主人公",
          "主人公",
          "ラルヴァ"
        ],
        [
          "エーデルガルト",
          "ヒューベルト",
          "ドロテア",
          "フェルディナント",
          "ベルナデッタ",
          "カスパル",
          "ペトラ",
          "リンハルト"
        ],
        [
          "ディミトリ",
          "ドゥドゥー",
          "フェリクス",
          "メルセデス",
          "アッシュ",
          "アネット",
          "シルヴァン",
          "イングリット"
        ],
        [
          "クロード",
          "ローレンツ",
          "ヒルダ",
          "ラファエル",
          "リシテア",
          "イグナーツ",
          "マリアンヌ",
          "レオニー"
        ],
        [
          "ユーリス",
          "バルタザール",
          "コンスタンツェ",
          "ハピ"
        ]
      ]
      const tweetHashtag = "&hashtags=FE無双風花雪月,FE無双";
      const tweetUrl = "&url=https://www.gamecity.ne.jp/fe_fs/tweet/";


      const setModal = (name, type) => {
        $(name).modaal({
          background: 'transparent',
          type: type,
          before_open: function (e) {
            $("#content").css({ "filter": "blur(5px)" });
            $("#navigation").css({ "filter": "blur(5px)" });
            $("#footer").css({ "filter": "blur(5px)" });
            switch (name) {
              case '.modal-chara':
                const startIndex = $(e.currentTarget).parent().index();
                let num = e.currentTarget.href.slice(-1);
                eval("modalSlider" + num).slideTo(startIndex);
                break;
            }
          },
          after_open: function () {
            //-モーダルのクリック計測
            $('.modaal-content a').click(function () {
              var j = $(this).attr('data-eventTrack');
              var ahref = $(this).attr('href') + '_name:' + j;
              gtag('event', 'Click', { 'event_category': 'EventTracker_GTM', 'event_label': ahref, 'non_interaction': true });
            });
          },
          before_close: function () {
            $("#content").css({ "filter": "blur(0)" });
            $("#navigation").css({ "filter": "blur(0)" });
            $("#footer").css({ "filter": "blur(0)" });
          }
        });
      }

      const setSwiper = (areaNum) => {
        modalSlider1 = new Swiper('#modal-slider1', {
          slidesPerView: 1,
          spaceBetween: 40,
          speed: 500,
          slideTo: 0,
          touchRatio: 0.4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
        modalSlider2 = new Swiper('#modal-slider2', {
          slidesPerView: 1,
          spaceBetween: 40,
          speed: 500,
          slideTo: 0,
          touchRatio: 0.4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
        modalSlider3 = new Swiper('#modal-slider3', {
          slidesPerView: 1,
          spaceBetween: 40,
          speed: 500,
          slideTo: 0,
          touchRatio: 0.4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
        modalSlider4 = new Swiper('#modal-slider4', {
          slidesPerView: 1,
          spaceBetween: 40,
          speed: 500,
          slideTo: 0,
          touchRatio: 0.4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
        modalSlider5 = new Swiper('#modal-slider5', {
          slidesPerView: 1,
          spaceBetween: 40,
          speed: 500,
          slideTo: 0,
          touchRatio: 0.4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
      }

      const setTweetBtn = (areaNum, charaNum, facialNum) => {
        const text = tweetLink + tweetCharaNames[areaNum - 1][charaNum - 1] + tweetTexts[areaNum - 1] + tweetHashtag + tweetUrl + 'c_0' + areaNum + '_0' + charaNum + '_0' + facialNum + '.html';
        const tgtChara = $('#modal-slider' + areaNum + ' .chara-modal').eq(charaNum - 1);
        $('.chara-modal__tweetbtn', tgtChara).attr('href', text);
      }

      const setTab = (areaNum) => {
        $(".chara-modal__btn a").on('click', (e) => {
          e.preventDefault();

          //ボタン
          $(e.currentTarget).parent().siblings().children().removeClass('on');
          $(e.currentTarget).addClass('on');

          //イメージ
          let facialNum = $(e.currentTarget).parent().index();
          let charaNum = $(e.currentTarget).parent().parent().parent().parent().index();

          $(e.currentTarget).parent().parent().prev().children().removeClass('on');
          $(e.currentTarget).parent().parent().prev().children().eq(facialNum).addClass('on');

          //ボタン
          setTweetBtn(areaNum, charaNum + 1, facialNum + 1);

        });
        $(".chara-modal__tweetbtn").on('click', (e) => {
          window.open(encodeURI(decodeURI(e.currentTarget.href)), 'twwindow', 'width=550, height=450, personalbar=0, toolbar=0, scrollbars=1'); return false;
        });
      }

      //- キャラクターポップアップ用 forでcharaModalLength回す
      for (let i = 1; i <= charaModalLength.length; i++) {//-キャラ枠


        const charaElm = document.createElement('div');
        charaElm.id = 'cm-' + i;
        charaElm.className = 'modal-target';

        const swiperElm = document.createElement('div');
        swiperElm.id = 'modal-slider' + i;
        swiperElm.className = 'swiper swiper-modal';
        charaElm.appendChild(swiperElm);

        const swiperWrapperElm = document.createElement('div');
        swiperWrapperElm.className = 'swiper-wrapper';
        swiperElm.appendChild(swiperWrapperElm);

        for (let j = 1; j <= charaModalLength[i - 1]; j++) {//-キャラ種 1-*

          const swiperSlideElm = document.createElement('div');
          swiperSlideElm.className = 'chara-modal swiper-slide num' + i;
          swiperWrapperElm.appendChild(swiperSlideElm);

          const containerElm = document.createElement('div');
          containerElm.className = 'chara-modal__container';
          swiperSlideElm.appendChild(containerElm);

          const nameElm = document.createElement('h3');//-名前
          nameElm.className = 'chara-modal__name';
          containerElm.appendChild(nameElm);

          const nameImgElm = document.createElement('img');//-名前-画像
          nameImgElm.src = testDir + '/fe_fs/assets/img/world_modal_name_0' + i + '_0' + j + '.png';
          nameElm.appendChild(nameImgElm);

          const imageElm = document.createElement('div');//-キャラ画像
          imageElm.className = 'chara-modal__image';
          containerElm.appendChild(imageElm);

          const btnElm = document.createElement('div');//-切り替えボタン
          btnElm.className = 'chara-modal__btn';
          containerElm.appendChild(btnElm);

          const tweetbtnElm = document.createElement('a');//-ツイートボタン
          const tweetbtnPElm = document.createElement('p');//-ツイートボタン
          const tweetbtnAnimElm = document.createElement('div');//-ツイートボタン
          tweetbtnElm.className = 'chara-modal__tweetbtn';
          tweetbtnAnimElm.className = 'animbox';
          tweetbtnElm.href = tweetLink + tweetCharaNames[i - 1][j - 1] + tweetTexts[i - 1] + tweetHashtag + tweetUrl + 'c_0' + i + '_0' + j + '_01.html';
          tweetbtnElm.rel = "nofollow"
          tweetbtnPElm.innerHTML = "この画像をツイートする";
          tweetbtnElm.dataset.eventtrack = 'tweet';
          tweetbtnElm.appendChild(tweetbtnAnimElm);
          tweetbtnElm.appendChild(tweetbtnPElm);
          containerElm.appendChild(tweetbtnElm);

          for (let k = 1; k <= facialLength; k++) {//-キャラ表情 1-3
            //-画像
            let classOn = "";
            if (k == 1) { classOn = "on" }
            const facialImg = document.createElement('img');
            facialImg.className = classOn;
            facialImg.src = testDir + '/fe_fs/assets/img/world_modal_chara_0' + i + '_0' + j + '_0' + k + '.png';
            imageElm.appendChild(facialImg);

            //-切り替えボタン
            const btnListElm = document.createElement('li');
            const btnAElm = document.createElement('a');
            btnAElm.className = classOn;
            btnAElm.innerHTML = '表情 ' + k;
            btnListElm.appendChild(btnAElm);
            btnElm.appendChild(btnListElm);

          }
        }

        const prevElm = document.createElement('div');
        prevElm.className = 'swiper-button-prev';
        const nextElm = document.createElement('div');
        nextElm.className = 'swiper-button-next';

        swiperElm.appendChild(prevElm);
        swiperElm.appendChild(nextElm);

        modalTarget.appendChild(charaElm);
        if (charaModalLength[i - 1] != 0) { setTab(i); }
        if (i == charaModalLength.length) { setSwiper(); }

      }


      //-modalもforで回す
      setModal(".modal-chara", "inline");


      break;

    case testDir + '/fe_fs/system/': //-システムページ

      var sliderThumbnail = new Swiper('.cycle-slider-dot', {
        slidesPerView: 3,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        speed: 600,
      });

      var sliderMain = new Swiper('.cycle-slider', {
        slidesPerView: 1,
        loop: true,
        loopAdditionalSlides: 2,
        centeredSlides: true,
        speed: 600,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: sliderThumbnail
        },
        on: {
          transitionStart: function () {
            setTimeout(() => {
              $(".swiper-slide video").get(0).pause();
            }, 100);
          },
          transitionEnd: function () {
            setTimeout(() => {
              $(".swiper-slide-active video").get(0).currentTime = 0;
              $(".swiper-slide-active video").get(0).play();
            }, 100);
          },
        }
      });

      //- 動画追加
      $('.system-01').html('<video muted autoplay playsinline loop id ="system-01"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_01.webm" type="video/webM"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_01.mp4" type="video/mp4"></video>');

      $('.system-02').html('<video muted autoplay playsinline loop id ="system-02"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_02.webm" type="video/webM"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_02.mp4" type="video/mp4"></video>');

      $('.system-03').html('<video muted autoplay playsinline loop id ="system-03"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_03.webm" type="video/webM"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_03.mp4" type="video/mp4"></video>');

      $('.training-movie').html('<video muted autoplay playsinline loop id ="system-training"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_training.webm" type="video/webM"><source src="https://download1.gamecity.ne.jp/fe_fs_jigdp672s66n/system_training.mp4" type="video/mp4"></video>');

      break;



    case testDir + '/fe_fs/usersvoice/': //-ユーザーボイス

      let isOn = false;

      $('.voicelist-hide').css({ 'display': 'none' });

      $('.voicelist-btn a').on('click', () => {
        if (isOn) {
          $('.voicelist-hide').css({ 'display': 'none' });
          $('.voicelist-btn a p').html('もっと見る');
          $('.voicelist-btn a img').css({ 'transform':'rotate(90deg)'});
          isOn = false
        } else {
          $('.voicelist-hide').css({ 'display': 'flex' });
          $('.voicelist-btn a p').html('閉じる');
          $('.voicelist-btn a img').css({ 'transform':'rotate(-90deg)'});
          isOn = true
        }
      })

      break;

  };


}


// 共通

const scrollToAnker = (hash) => {
  let target = $(hash);
  let position = target.offset().top - 50;
  $('body,html').stop().animate({ scrollTop: position }, 500, 'swing');
}



$(function () { //-初回ロード後の初期化

  //GAイベントの設定（GTMで追加しているイベントは削除）
  setClickEvent();
  setNavigation('.fixobj');
  setSizes();
  init();

  //-ナビゲーションの初期化

  //- マウス移動によるメニューバーの非表示操作
  //- if (isPC) {mousemoveSet();}

  //- if (testDir != '') {//テスト用URLの指定がある場合
  //-   $('.nav-item a').each((index,element) => {
  //-     let hreftext = testDir + $(element).attr('href');
  //-     $(element).attr('href', hreftext);
  //-   }
  //-   );

  //- }

  barba.init({
    transitions: [{
      name: 'opacity-transition',
      leave(data) {
        $('#common-wrapper a').off();
        return gsap.to(data.current.container, {
          duration:0.5,
          opacity: 0
        });
      },
      beforeEnter(data) {
        replaceHeadTags(data.next);
      },
      enter(data) {
        scrollTo(0, 0);
          // setAnimation();
        // replaceHeadTags(data);
        return gsap.from(data.next.container, {
            duration:0,
            opacity: 0
          });
        }
    }],
    views: [
      {
        namespace: 'top',
        beforeEnter(data) {
          document.querySelector('body').classList.add('top');
        },
        afterLeave(data) {
          document.querySelector('body').classList.remove('top');
        }
      },
      {
        namespace: 'world',
        beforeEnter(data) {
          document.querySelector('body').classList.add('world');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('world');
        }
      },
      {
        namespace: 'system',
        beforeEnter(data) {
          document.querySelector('body').classList.add('system');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('system');
        }
      },
      {
        namespace: 'movie',
        beforeEnter(data) {
          document.querySelector('body').classList.add('movie');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('movie');
        }
      },
      {
        namespace: 'special',
        beforeEnter(data) {
          document.querySelector('body').classList.add('special');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('special');
        }
      },
      {
        namespace: 'update',
        beforeEnter(data) {
          document.querySelector('body').classList.add('update');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('update');
        }
      },
      {
        namespace: 'trial',
        beforeEnter(data) {
          document.querySelector('body').classList.add('trial');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('trial');
        }
      },
      {
        namespace: 'lowerdafault',
        beforeEnter(data) {
          document.querySelector('body').classList.add('lowerdefault');
        },
        afterLeave (data) {
          document.querySelector('body').classList.remove('lowerdefault');
        }
      }
    ]
    // ...
  });


  // titleタグ以外のmetaタグの情報の書き換えを行う
  const replaceHeadTags = target => {
    const head = document.head;
    const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    const newPageHead = document.createElement('head');
    newPageHead.innerHTML = targetHead;
    const removeHeadTags = [
      "meta[name='keywords']",
      "meta[name='description']",
      "meta[property^='fb']",
      "meta[property^='og']",
      "meta[name^='twitter']",
      "meta[name='robots']",
      'meta[itemprop]',
      'link[itemprop]',
      "link[rel='prev']",
      "link[rel='next']",
      "link[rel='canonical']"
    ].join(',');
    const headTags = [...head.querySelectorAll(removeHeadTags)];
    headTags.forEach(item => {
      head.removeChild(item);
    });
    const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)];
    newHeadTags.forEach(item => {
      head.appendChild(item);
    });
  };

  //-- Googleアナリティクスに情報を送る
  barba.hooks.after(() => {


    //-ページビューの送信
    sendPageView();

        //-GAイベントトラック
        setClickEvent();

    // setSizes();
    init();
    setAnimation();


  });

});

//-GAへのクリックイベント送信のための設定
const sendPageView = () => {

  gtag('config', 'G-17JJJXB29C');
  gtag('config', 'UA-115296195-10', {
    page_title: document.title ,
    page_location: location.href ,
    page_path:location.pathname
  });

}

//-GAへのクリックイベント送信のための設定
const setClickEvent = () => {

  $('a').unbind('click');//-eventTracker_GTM.jsのclickを解除
  $('a').off('click');


  if(typeof(gtag) == "function"){

    //クリックイベント

    $('a').click(function(){
      var j = $(this).attr('data-eventTrack');
      if(j === undefined){
        var ahref = $(this).attr('href');
        gtag('event', 'Click', {'event_category': 'EventTracker_GTM','event_label': ahref,'non_interaction': true});
      }else if('shopLink'){
        var ahref = $(this).attr('href')+'_name:' + j;
        gtag('event', 'Click', { 'event_category': 'EventTracker_GTM', 'event_label': ahref, 'non_interaction': false });
        // gtag('event', 'purchase');//GA4用
        if(typeof eventTracker_option_shopLink == 'function'){eventTracker_option_shopLink();}//オプションがある場合実行
      }else{
        var ahref = $(this).attr('href')+'_name:' + j;
        gtag('event', 'Click', {'event_category': 'EventTracker_GTM','event_label': ahref,'non_interaction': true});
      }
    });

  }else{
    console.log('error_eventTracker_GTM_nofuncGA');
  }

}

//-カーソル位置の取得
//- const mousemoveSet = () => {
//-   const range = 100;
//-   $(window).on('mousemove', function (e) {

//-     // console.log('TOP' + e.clientY + ' , LEFT' + e.clientX);
//-     if (e.clientY > windowHeight - range && window.scrollY + windowHeight <= navPosition) {
//-       navigationMove("fixed");
//-     } else {
//-       // navigationMove("hide");
//-     }
//-   });
//- }


//-リサイズ時の処理

var resizeTimer;
var lastInnerWidth = window.innerWidth ;

window.addEventListener('resize', function (event) {
  if (!resizeTimer) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function () {
    if (isSP && lastInnerWidth != window.innerWidth) {//-SPのときは横幅の変更のみ
      lastInnerWidth = window.innerWidth;
      onResize();
    } else if(isPC) {
      onResize();
    }
  }, 1000);

});

const onResize = () => {
  setSizes();
  //- location.reload(); //
}


